import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AddEditPocComponent } from './addEditPoc.component';
import { Store } from '@ngrx/store';
import { PocModel } from '../../../model/index';
import { PocService } from '../../../services/index';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

@Component({
    selector: 'poc-tab',
    templateUrl: './poc.component.html',
})
export class PocMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public pocdata: any[] = [];

    isLoadMask: Promise<any>;
    pocData: PocModel[];
    isLoading: boolean = false;
    scrollTimeout: any;
    suppressPaging: boolean = false;
    subscribeAuth;
    usertype = '';
    filterData={
        search_data:''
    }

    constructor(public store: Store<fromRootStore.State>,private pocService: PocService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70,maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'NAME', prop: 'name', width: 300, minWidth: 300,maxWidth: 300 },
            { name: 'POV', prop: 'pov_name', width: 250, minWidth: 250,maxWidth: 250 },
            { name: 'Reference', prop: 'reference', width: 200, minWidth: 200,maxWidth: 200 },
            { name: 'FEES', prop: 'fees', width: 100, minWidth: 100,maxWidth: 100, cellClass: 'cell-right' },
            // { name: 'Branch', prop: 'branch', width: 180, minWidth: 180,maxWidth: 180 },
            { name: 'Status', prop: 'test_status', width: 180, minWidth: 180,maxWidth: 180 },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 100,maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });      
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {

            this.page.offset = pageInfo.offset;
            this.getPocList();
        
    }

    /**
   * Called whenever the user changes the sort order
   */
/*     sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getPocList();
    } */
    onScroll() {
        this.suppressPaging = true;

        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);

    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getPocList();
    }

    clearFilter(): void {
        this.filterData = {
            "search_data": ""
        };
        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getPocList();
    }

    getPocList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter:this.filterData['search_data']
        };
        let that = this;
        this.isLoadMask = this.pocService
            .getPocList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.pocData = res.data;
            });
    }

    bsModalRef: BsModalRef;
    onAddEditPoc(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);
        this.bsModalRef = this.modalService.show(AddEditPocComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        if (mode === 'Edit') {
            row.pov = row.pov_name ? row.pov_name.split(',') : [];
        }

        this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                that.usertype = auth['usertype'];
                if (auth['usertype'] != 'Super_Admin' && auth['usertype'] != 'Admin' && auth['usertype'] != 'Accounts' ) {
                    if(mode=='Add'){
                        row['branch_id'] = auth['branch_id'];
                    }
                    else{
                        // if( row['branch_id'] == null)
                        // {
                            row['branch_id'] = auth['branch_id'];
                        // }
                    }
                   
                }
                

                that.bsModalRef.content.title = mode + ' POC Details';
                that.bsModalRef.content.pocdata = Object.assign({}, row);
                that.bsModalRef.content.pocLoadEvent.subscribe(($e) => {
                    that.getPocList();
                });
					
                }
        });

      
    }

    onDeletePoc(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Testing Type: ' + row.name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.pocService
                .deletePoc(row.id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getPocList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/poc/poc.component.ts